<div class="mb-3">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <div class="input-group">
    <span class="input-group-text fw-semibold small bg-light">{{ prefix }}</span>
    <input
      type="text"
      class="form-control"
      [class.is-invalid]="hasError"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      [value]="displayValue"
      (input)="handleInput($event)"
      (blur)="handleBlur()"
      inputmode="numeric"
    >
  </div>

  <small *ngIf="helpText && !hasError" class="form-text text-muted">{{ helpText }}</small>
  <is-form-error *ngIf="control" [control]="control"></is-form-error>
</div>
